import type { SwitchProps } from '@mui/material/Switch'
import FormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import { StyledSwitch } from './style'
import { CSSProperties } from 'react'

interface Props {
  formControlLabelProps?: FormControlLabelProps
  switchProps?: SwitchProps
  label?: string
}

const Switch: React.FC<Props> = ({
  label,
  switchProps,
  formControlLabelProps,
}) => {
  return (
    <FormControlLabel
      control={<StyledSwitch {...switchProps} />}
      {...formControlLabelProps}
      style={{ marginLeft: 0 }}
      label={
        <Typography
          variant="body_s_regular"
          color={switchProps?.checked ? 'typoColor.main' : 'darkGray.main'}
        >
          {label}
        </Typography>
      }
      sx={{ gap: 2 }}
    />
  )
}

export default Switch
